<template>
  <div id="app" ref="document">
    <!-- Row start -->
    <div class="container">
      <div class="row gutters">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
          <div class="custom-actions-btns mb-1">
            <v-btn
                @click="exportToPDF()"
                elevation="0"
                :ripple="false"
                height="43"
                class="
            font-weight-bold
            text-uppercase
            btn-default
            bg-gradient-secondary
            py-2
            px-6
            me-2
            mb-sm-0 mb-2
          "
                color="#5e72e4"
                small
            >Download</v-btn
            >
          </div>
        </div>
      </div>
    </div>
    <!-- Row end -->
    <div id="element-to-convert">
      <div class="container">
        <div class="row gutters">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card">
              <div class="card-body p-0">
                <div class="invoice-container">
                  <div class="invoice-header mt-3">
                    <!-- Row start -->
                    <div class="row gutters">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <address class="text-right">
                          {{ new Date(information.date_created).toDateString() }}<br>
                          Harare, {{information.currency}} Batch.<br>
                          <b>Uploaded By</b> :  {{information.created_by}}<br>
                          <b>Approved By</b> : {{information.approved_by}} <br>
                        </address>
                      </div>
                    </div>
                    <!-- Row end -->
                  </div>
                  <div class="invoice-body mt-10">
                    <!-- Row start -->
                    <div class="row utters">
                      <div class="col-lg-12 col-md-12 col-sm-12">
                        <div class="table-responsive">
                          <table class="table custom-table">
                            <thead>
                            <tr>
                              <th>Date</th>
                              <th>Month</th>
                              <th>Record</th>
                              <th>Company Name</th>
                              <th>Payment Method</th>
                              <th>Other</th>
                              <th>General Fund</th>
                              <th>Interest</th>
                              <th>Unallocated Amount</th>
                              <th>Total </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="info in information.records">
                              <td class="text-xxs invoice-details">{{ info.date_received }}</td>
                              <td class="text-xxs invoice-details">{{ info.week_range }}</td>
                              <td class="text-xxs invoice-details">{{ info.record_number }}</td>
                              <td class="text-xxs invoice-details">{{ info.CompanyName }}</td>
                              <td class="text-xxs invoice-details">{{ info.payment_type }}</td>
                              <td class="text-xxs invoice-details text-center"> {{ info.other }}</td>
                              <td class="text-xxs invoice-details text-center"> {{ info.general_fund}}</td>
                              <td class="text-xxs invoice-details text-center"> {{ info.interest}}</td>
                              <td class="text-xxs invoice-details text-center"> {{ info.unallocated_amount}}</td>
                              <td class="text-xxs invoice-details text-center"> {{ info.total_amount}}</td>
                            </tr>
                            <tr>
                              <td colspan="5">&nbsp;</td>
                              <td class="text-xs invoice-details text-center"> <b>{{ information.total_other }}</b></td>
                              <td class="text-xs invoice-details text-center"> <b>{{ information.total_general_fund }}</b></td>
                              <td class="text-xs invoice-details text-center"> <b>{{ information.total_interest }}</b></td>
                              <td class="text-xs invoice-details text-center"> <b>{{ information.total_unallocated }}</b></td>
                              <td class="text-xs invoice-details text-center"> <b>{{ information.total_total}}</b></td>
                            </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <!-- Row end -->
                  </div>
                  <div class="invoice-header mt-3">
                  </div>
                  <div class="invoice-footer mt-3">
                    System generated document, no signature is required.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "app",
  data() {
    return {
      information: [],
      invoiceNumber: "",
      overlay: false,
    };
  },

  created() {
    this.getLedgerInfo();
  },
  computed: {
    ...mapState(['base_url']),
  },
  methods: {
    exportToPDF() {
      html2pdf(document.getElementById("element-to-convert"), {
        margin: 1,
        filename: "NEC Ledger.pdf",
      });
    },
    async getLedgerInfo() {
      this.overlay = true
      const JWTToken = this.$store.getters.accessToken
      axios.get(this.base_url + '/ledger/get-ledger-info/' + this.$route.query.id,{ headers: { Authorization: `Bearer ${JWTToken}` } })
          .then(res => {
            if (res.status === 200) {
              this.information = res.data
              this.overlay = false
            } else if (res.status === 404) {
              this.overlay = false
            } else {
              this.overlay = false
            }
          })
    },
  },
};
</script>

<style>
body{
  color: #222222;
  background: #f5f6fa;
  position: relative;
  height: 100%;
}
.invoice-container {
  padding: 1rem;
}
.invoice-container .invoice-header .invoice-logo {
  margin: 0.8rem 0 0 0;
  display: inline-block;
  font-size: 1.6rem;
  font-weight: 700;
  color: #2e323c;
}
.invoice-container .invoice-header .invoice-logo img {
  max-width: 130px;
}
.invoice-container .invoice-header address {
  font-size: 0.8rem;
  color: #9fa8b9;
  margin: 0;
}
.invoice-container .invoice-details {
  margin: 1rem 0 0 0;
  padding: 0.4rem;
  background: #f5f6fa;
}
.invoice-container .invoice-details .invoice-num {
  text-align: right;
  font-size: 0.4rem;
}
.invoice-container .invoice-body {
  padding: 1rem 0 0 0;
}
.invoice-container .invoice-footer {
  text-align: center;
  font-size: 0.7rem;
  margin: 5px 0 0 0;
}

.invoice-status {
  text-align: center;
  padding: 1rem;
  background: #ffffff;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  margin-bottom: 1rem;
}
.invoice-status h2.status {
  margin: 0 0 0.8rem 0;
}
.invoice-status h5.status-title {
  margin: 0 0 0.8rem 0;
  color: #9fa8b9;
}
.invoice-status p.status-type {
  margin: 0.5rem 0 0 0;
  padding: 0;
  line-height: 150%;
}
.invoice-status i {
  font-size: 1.5rem;
  margin: 0 0 1rem 0;
  display: inline-block;
  padding: 1rem;
  background: #f5f6fa;
  -webkit-border-radius: 50px;
  -moz-border-radius: 50px;
  border-radius: 50px;
}
.invoice-status .badge {
  text-transform: uppercase;
}

@media (max-width: 767px) {
  .invoice-container {
    padding: 1rem;
  }
}


.custom-table {
  width: 100%;
  border: 1px solid #e0e3ec;
}
.custom-table thead {
  background: #e0e3ec;
}
.custom-table thead th {
  border: 0;
  padding: 0.3rem;
  color: #000000;
}
.custom-table > tbody tr:hover {
  background: #fafafa;
}
.custom-table > tbody tr:nth-of-type(even) {
  background-color: #ffffff;
}
.custom-table > tbody td {
  border: 1px solid #e6e9f0;
}


.card {
  background: #ffffff;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: 0;
  margin-bottom: 1rem;
}

.text1-success {
  color: #005778 !important;
}

.text1-dark {
  color: #0c0c0c !important;
}

.text-muted {
  color: #90a5c1 !important;
}

.custom-actions-btns {
  margin: auto;
  display: flex;
  justify-content: flex-end;
}

.custom-actions-btns .btn {
  margin: .3rem 0 .3rem .3rem;
}

</style>
